import {
  KeycloakOptions,
  KeycloakService,
} from 'keycloak-angular';
import { KeycloakConfig } from 'keycloak-js';


import { ApplicationRef, Injectable, Type } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ConfigHeadersService } from '../../services/config-headers.service';

/** Service to handle application bootstrap */
@Injectable()
export class BootstrapAuthService {
  constructor(
    private readonly configHeadersService: ConfigHeadersService,
    private readonly keycloakService: KeycloakService,
  ) {}

  public getToken(): any {
    return this.keycloakService.getKeycloakInstance().token;
  }

  public getName(): any {
      if (
        this.keycloakService.getKeycloakInstance().profile?.firstName ===
          undefined &&
        this.keycloakService.getKeycloakInstance().profile?.lastName ===
          undefined
      ) {
        return 'N/A';
      }

      return (
        this.keycloakService.getKeycloakInstance().profile?.firstName +
        ' ' +
        this.keycloakService.getKeycloakInstance().profile?.lastName
      );
  }

  public logout(): void {
    this.keycloakService.logout();
  }

  /** Bootstrap angular with keycloak protection */
  // tslint:disable-next-line: no-console
  public async bootstrapWithAuth(
    appRef: ApplicationRef,
    bootstrapComponent: Type<any>,
  ): Promise<void> {
    const initOptions = await this.getKeycloakInitSettings();
    this.keycloakService
      .init(initOptions)
      .then((hasAuth) => {
        // If has authentication token, start app
        if (hasAuth) {
          appRef.bootstrap(bootstrapComponent);
          return;
        }

        // If not authenticated, proced with auth process
        this.keycloakService
          .login()
          .then(() => appRef.bootstrap(bootstrapComponent));
      })
      .catch((err) => {
        // tslint:disable-next-line: no-console
        console.error('Error at authentication');
        if (!environment.production) {
        // tslint:disable-next-line: no-console
          console.error(err);
        }
      });
  }

  /** Load keycloak init options */
  private async getKeycloakInitSettings(): Promise<KeycloakOptions> {
    const config = await this.getKeycloakConfig();
    // tslint:disable-next-line: no-console
    console.warn('Starting keycloak with: ' + config.url);
    const options: KeycloakOptions = {
      config,
      loadUserProfileAtStartUp: true,
      enableBearerInterceptor: true,
      initOptions: {
        checkLoginIframe: false,
        redirectUri: window.location.href,
      },
    };

    return options;
  }

  /** Load keycloak configuration from HEADERS */
  private async getKeycloakConfig(): Promise<KeycloakConfig> {
    return this.configHeadersService
      .getHeaders()
      .pipe(
        map((h) => {
          return {
            clientId: h.clientId,
            url: h.authUrl,
            realm: h.realm,
          } as KeycloakConfig;
        }),
      )
      .toPromise();
  }
}
